import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { FormRow } from '@gravity-ui/components';
import { CirclePlus, PersonPlus, Xmark } from '@gravity-ui/icons';
import { Button, Icon, Modal, TextInput, Tooltip } from '@gravity-ui/uikit';
import { zodResolver } from '@hookform/resolvers/zod';

import { useAddEstablishmentMutation } from 'store/api';

import type { EstablishmentAddForm } from './use-validation';
import { useEstablishmentAddValidation } from './use-validation';
import { ENTER_ESTABLISHMENT_NAME } from 'features/admin-mode/constants';

import styles from './styles.module.scss';

export const EstablishmentAddInput = ({ open, setOpen, onAdded }: any) => {
	const [addEstablishment] = useAddEstablishmentMutation();

	const { establishmentAddSchema } = useEstablishmentAddValidation();

	const methods = useForm<EstablishmentAddForm>({
		resolver: zodResolver(establishmentAddSchema),
		defaultValues: {
			name: '',
		},
	});

	const {
		handleSubmit,
		register,
		reset,
		formState: { errors, isSubmitted, isValid },
	} = methods;

	const onSubmit = async (data: EstablishmentAddForm) => {
		try {
			await addEstablishment(data).unwrap();
			const newName = data.name;

			setOpen(false);

			onAdded?.(newName);

			toast.success('Учреждение успешно добавлено');
			reset();
		} catch (error: any) {
			toast.error(error.data.message);
		}
	};

	return (
		<div className={styles.container}>
			<FormProvider {...methods}>
				<form onSubmit={handleSubmit(onSubmit)} className={styles.container__establishment_form}>
					<TextInput
						size="l"
						placeholder={ENTER_ESTABLISHMENT_NAME}
						hasClear
						{...register('name', { required: true })}
						validationState={isSubmitted && errors.name ? 'invalid' : undefined}
						errorPlacement="inside"
						errorMessage={isSubmitted && errors.name ? 'Обязательно для заполнения' : undefined}
					/>

					<Tooltip content="Сохранить" disabled={isValid} openDelay={100} placement="top">
						<div tabIndex={0}>
							<Button size="l" type="submit">
								<Icon data={CirclePlus} size={18} />
							</Button>
						</div>
					</Tooltip>
				</form>
			</FormProvider>
		</div>
	);
};
